import { FlexColumnCenterVertical, Icon, IconType } from '@main/core-ui';
import { SanitizeHtml } from '@main/pc-core-components';
import { ID } from '@main/schema-utils';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectDataSubjects } from '../../containers/ActiveDataSubject/selectors';
import { StyledReactSelect } from '../SelectPartition/wrappers';
import { selectDataSubjectTypeMessages } from './messages';

export interface SelectDataSubjectTypeOption {
  /** Subject id */
  id: ID<'subject'>;
  /** Subject type */
  type: string;
}

interface SelectDataSubjectTypeProps {
  /** default data subject type */
  value: SelectDataSubjectTypeOption;
  /** Callback to handle the change of a data subject type */
  onChange: (type: SelectDataSubjectTypeOption) => void;
}

/**
 * Component to Select DataSubjectType.
 */
export const SelectDataSubjectType: React.FC<SelectDataSubjectTypeProps> = ({
  value,
  onChange,
}) => {
  const { formatMessage } = useIntl();
  const subjects = useSelector(selectDataSubjects);
  const options = subjects.map((subject) => ({
    id: subject.id,
    value: subject.type,
    label: formatMessage(subject.title),
    logo: <Icon type={subject.icon as IconType} />,
    variant: 'light',
  }));
  const defaultOption = options.find((option) => option.value === value.type)!;

  return (
    <>
      {options.length > 1 && (
        <FlexColumnCenterVertical style={{ flex: '1' }}>
          <p>
            <SanitizeHtml
              html={formatMessage(
                selectDataSubjectTypeMessages.selectDataSubjectType,
              )}
            />
          </p>
          <StyledReactSelect
            isMulti={false}
            variant="light"
            id="select-dataSubject-type"
            options={options}
            value={defaultOption}
            isClearable={false}
            getOptionLabel={(option) => option.label}
            onChange={(option) => {
              if (option) onChange({ type: option.value, id: option.id });
            }}
          />
        </FlexColumnCenterVertical>
      )}
    </>
  );
};
